function FinalizeAccountController($scope,$rootScope, $routeParams) {
  'ngInject';

  //Display Password Reset Modal
	jQuery(document).ready(function ($) {

		$rootScope.MemberId = $routeParams.MemberId
		$rootScope.Password = '';

		var date = new Date();
		var minutes = 60000;
		date.setTime(date.getTime() + (minutes * 60 * 1000));
		Cookies.set('Finalize_Member', $rootScope.MemberId, { expires: date });

		//Make the modal the focus
		$('.close').hide();
		setTimeout(function () {
			$('#modal .bg').unbind();
		}, 1000);

    $('#modal').show();
		$('#invite').fadeIn(500);

  });
};

export default {
  name: 'finalizeaccountCTRL',
  fn: FinalizeAccountController
}